<template>
  <div class="register-page">
    <div class="register-header">
      <h2>特约商户入驻申请</h2>
      <p>请填写以下信息完成入驻申请</p>
    </div>

    <div v-if="step === 0" class="register-form">
      <el-form :model="form" :rules="rules" ref="registerForm" label-width="120px" size="small">

        <el-divider content-position="left">商户基本信息</el-divider>
        <el-form-item label="商户简称" prop="merchant_shortname">
          <el-input v-model.trim="form.merchant_shortname" placeholder="请输入商户简称，在支付完成页向买家展示"></el-input>
        </el-form-item>
        <el-form-item label="客服电话" prop="service_phone">
          <el-input v-model.trim="form.service_phone" placeholder="请输入客服电话"></el-input>
        </el-form-item>

        <el-divider content-position="left">超级管理员信息</el-divider>
        <el-form-item label="管理员类型" prop="contact_type">
          <el-select v-model="form.contact_type" placeholder="请选择" style="width: 100%;">
            <el-option label="经营者/法定代表人" value="LEGAL"></el-option>
            <el-option label="经办人" value="SUPER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理员姓名" prop="contact_name">
          <el-input v-model.trim="form.contact_name" placeholder="请输入超级管理员姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile_phone">
          <el-input v-model.trim="form.mobile_phone" placeholder="请输入超级管理员手机号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="contact_email">
          <el-input v-model.trim="form.contact_email" placeholder="请输入超级管理员邮箱"></el-input>
        </el-form-item>

        <el-divider content-position="left">主体信息</el-divider>
        <el-form-item label="主体类型" prop="subject_type">
          <el-select v-model="form.subject_type" placeholder="请选择主体类型" style="width: 100%;">
            <el-option label="个体工商户" value="SUBJECT_TYPE_INDIVIDUAL"></el-option>
            <el-option label="企业" value="SUBJECT_TYPE_ENTERPRISE"></el-option>
            <el-option label="党政机关及事业单位" value="SUBJECT_TYPE_GOVERNMENT"></el-option>
            <el-option label="其他组织" value="SUBJECT_TYPE_OTHERS"></el-option>
          </el-select>
        </el-form-item>

        <template v-if="form.subject_type && form.subject_type !== 'SUBJECT_TYPE_INDIVIDUAL'">
          <el-form-item label="营业执照号" prop="license_number">
            <el-input v-model.trim="form.license_number" placeholder="请输入统一社会信用代码"></el-input>
          </el-form-item>
          <el-form-item label="商户名称" prop="merchant_name">
            <el-input v-model.trim="form.merchant_name" placeholder="请输入营业执照上的商户名称"></el-input>
          </el-form-item>
          <el-form-item label="法人姓名" prop="legal_person">
            <el-input v-model.trim="form.legal_person" placeholder="请输入法人姓名"></el-input>
          </el-form-item>
        </template>

        <el-divider content-position="left">经营信息</el-divider>
        <el-form-item label="经营场景" prop="sales_scenes_type">
          <el-select v-model="form.sales_scenes_type" multiple placeholder="请选择经营场景" style="width: 100%;">
            <el-option label="公众号" value="SALES_SCENES_MP"></el-option>
            <el-option label="小程序" value="SALES_SCENES_MINI_PROGRAM"></el-option>
            <el-option label="线下门店" value="SALES_SCENES_STORE"></el-option>
            <el-option label="APP" value="SALES_SCENES_APP"></el-option>
            <el-option label="互联网网站" value="SALES_SCENES_WEB"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="submitting" style="width: 100%;">提交申请</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div v-else-if="step === 1" class="step-container">
      <el-icon class="el-icon-loading" style="font-size: 40px; color: #409EFF;"></el-icon>
      <p style="margin-top: 20px; font-size: 16px; color: #606266;">正在提交申请，请稍候...</p>
    </div>

    <div v-else-if="step === 2" class="step-container">
      <el-result v-if="result.applyment_state === 'APPLYMENT_STATE_FINISHED'" icon="success" title="商户入驻已完成" subTitle="特约商户号已生成">
        <template slot="extra">
          <p>特约商户号: <b>{{ result.sub_mchid }}</b></p>
        </template>
      </el-result>
      <el-result v-else-if="result.applyment_state === 'APPLYMENT_STATE_REJECTED'" icon="error" title="申请已被驳回" subTitle="请根据驳回原因修改申请资料后重新提交">
      </el-result>
      <div v-else>
        <el-result icon="success" title="申请已提交" subTitle="请使用微信扫描以下二维码完成签约">
        </el-result>
        <div style="display: flex; justify-content: center; margin: 20px 0;">
          <div id="signQrContainer" ref="signQrContainer"></div>
        </div>
        <p style="text-align: center; font-size: 12px; color: #909399;">申请状态: {{ result.applyment_state_msg }}</p>
        <div style="text-align: center; margin-top: 15px;">
          <el-button type="primary" size="small" @click="refreshStatus" :loading="refreshLoading">刷新状态</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      step: 0,
      submitting: false,
      refreshLoading: false,
      form: {
        merchant_shortname: '',
        service_phone: '',
        contact_type: 'LEGAL',
        contact_name: '',
        mobile_phone: '',
        contact_email: '',
        subject_type: '',
        license_number: '',
        merchant_name: '',
        legal_person: '',
        sales_scenes_type: ['SALES_SCENES_MINI_PROGRAM']
      },
      rules: {
        merchant_shortname: [{ required: true, message: '请输入商户简称', trigger: ['blur', 'change'] }],
        service_phone: [{ required: true, message: '请输入客服电话', trigger: ['blur', 'change'] }],
        contact_type: [{ required: true, message: '请选择管理员类型', trigger: ['change'] }],
        contact_name: [{ required: true, message: '请输入管理员姓名', trigger: ['blur', 'change'] }],
        mobile_phone: [{ required: true, message: '请输入手机号', trigger: ['blur', 'change'] }],
        contact_email: [{ required: true, message: '请输入邮箱', trigger: ['blur', 'change'] }],
        subject_type: [{ required: true, message: '请选择主体类型', trigger: ['change'] }],
        sales_scenes_type: [{ required: true, message: '请选择经营场景', trigger: ['change'] }]
      },
      result: {
        applyment_state: '',
        applyment_state_msg: '',
        sign_url: '',
        sub_mchid: '',
        business_code: '',
        message: ''
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.registerForm.validate(async (valid) => {
        if (!valid) return;
        this.step = 1;
        this.submitting = true;
        try {
          const businessCode = 'APPLY_' + Date.now();
          const contactInfo = {
            contact_type: this.form.contact_type,
            contact_name: this.form.contact_name,
            mobile_phone: this.form.mobile_phone,
            contact_email: this.form.contact_email
          };
          const subjectInfo = {
            subject_type: this.form.subject_type
          };
          if (this.form.subject_type !== 'SUBJECT_TYPE_INDIVIDUAL') {
            subjectInfo.business_license_info = {
              license_number: this.form.license_number,
              merchant_name: this.form.merchant_name,
              legal_person: this.form.legal_person
            };
          }
          const requestData = {
            business_code: businessCode,
            contact_info: contactInfo,
            subject_info: subjectInfo,
            business_info: {
              merchant_shortname: this.form.merchant_shortname,
              service_phone: this.form.service_phone,
              sales_info: {
                sales_scenes_type: this.form.sales_scenes_type
              }
            }
          };
          const { data: submitRes } = await this.$http.post('/sub/merchant/applyment/submit', requestData);
          if (submitRes.code !== 200) {
            this.$message.error(submitRes.msg || '提交申请失败');
            this.step = 0;
            return;
          }
          await new Promise(resolve => setTimeout(resolve, 2000));
          await this.querySignUrl(businessCode);
        } catch (error) {
          this.$message.error('提交申请失败: ' + (error.message || '未知错误'));
          this.step = 0;
        } finally {
          this.submitting = false;
        }
      });
    },
    async querySignUrl(businessCode) {
      try {
        const { data: queryRes } = await this.$http.post('/sub/merchant/applyment/getSignUrl', {
          businessCode: businessCode
        });
        if (queryRes.code !== 200) {
          this.$message.error(queryRes.msg || '查询签约链接失败');
          this.step = 0;
          return;
        }
        this.result = queryRes.data;
        this.result.business_code = businessCode;
        this.step = 2;
        if (this.result.sign_url) {
          this.$nextTick(() => {
            this.generateSignQrCode(this.result.sign_url);
          });
        }
      } catch (error) {
        this.$message.error('查询签约链接失败');
        this.step = 0;
      }
    },
    generateSignQrCode(url) {
      const container = document.getElementById('signQrContainer');
      if (container) {
        container.innerHTML = '';
        new QRCode(container, {
          text: url,
          width: 256,
          height: 256,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      }
    },
    async refreshStatus() {
      this.refreshLoading = true;
      try {
        await this.querySignUrl(this.result.business_code);
        this.$message.success('状态已刷新');
      } catch (error) {
        this.$message.error('刷新失败');
      } finally {
        this.refreshLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.register-page {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
}
.register-header {
  text-align: center;
  margin-bottom: 30px;
  padding-top: 20px;
}
.register-header h2 {
  color: #303133;
  margin-bottom: 8px;
}
.register-header p {
  color: #909399;
  font-size: 14px;
}
.step-container {
  text-align: center;
  padding: 60px 20px;
}
</style>
